import React, { useState, useEffect, useRef, Suspense } from "react";
import styled from "styled-components";

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  font-family: "AllianceNo2-SemiBold", sans-serif;
`;

const useInView = (options) => {
  const [inView, setInView] = useState(false);
  const ref = useRef();
  const rootMargin = options?.rootMargin || "200px 0px";

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting === true) {
          setInView(true);
          observer.unobserve(entry.target);
        }
      },
      { rootMargin },
    );

    const currentRef = ref.current;
    currentRef && observer.observe(currentRef);

    return () => {
      currentRef && observer.unobserve(currentRef);
    };
  }, [rootMargin]);

  return [ref, inView];
};

const LazyInView = ({
  children,
  fallback = <LoadingWrapper>Loading...</LoadingWrapper>,
  rootMargin,
}) => {
  const [ref, inView] = useInView({ rootMargin });

  return (
    <div ref={ref}>
      {inView ? <Suspense fallback={fallback}>{children}</Suspense> : fallback}
    </div>
  );
};

export default LazyInView;
